import {JSX, useEffect, useState} from "react";
import {request} from "../../api/apiUtils";
import {CircularProgress} from "@mui/material";

type InitializeCsrfProps = {
    children: JSX.Element;
};

const CsrfInitializer = ({children}: InitializeCsrfProps) => {
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        const initialize = async () => {
            try {
                await request("/csrf", {method: "GET"});
            } catch (error) {
                console.error(error);
            } finally {
                setInitialized(true);
            }
        };

        void initialize();
    }, []);

    if (!initialized) {
        return <CircularProgress />;
    }

    return children;
};

export default CsrfInitializer;
